import { render } from "./SetNewPasswordForm.vue?vue&type=template&id=249305a5"
import script from "./SetNewPasswordForm.vue?vue&type=script&lang=js"
export * from "./SetNewPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LoginFlow/SetNewPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "249305a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('249305a5', __exports__)) {
    console.log('reload')
    api.reload('249305a5', __exports__)
  }
  
  module.hot.accept("./SetNewPasswordForm.vue?vue&type=template&id=249305a5", () => {
    console.log('re-render')
    api.rerender('249305a5', render)
  })

}


export default __exports__